<template>
  <div class="columns">

    <!-- //////////////////////////////////////////////////////////////////// -->

    <div class="column">

      <!-- Youtube ID -->
      <div class="field">
        <label class="label">Vimeo ID</label>
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder="t56JFBFFKUI"
            v-model="videoId"
            v-on:change="update" />
        </div>
      </div>
      <!--            -->

      <!-- Vimeo ID -->
      <div class="field">
        <label class="checkbox">
          <input
            type="checkbox"
            v-model="muted"
            v-on:change="update" />
          Muted
        </label>
      </div>
      <!--            -->

      <!-- Vimeo ID -->
      <div class="field">
        <label class="checkbox">
          <input
            type="checkbox"
            v-model="looped"
            v-on:change="update" />
          Looped
        </label>
      </div>
      <!--            -->

    </div>

    <!-- //////////////////////////////////////////////////////////////////// -->

    <div class="column">

      <!-- PREVIEW -->
      <div ref="preview" class="vimeo-preview-player"></div>

    </div>

  </div>
</template>

<script>

  import Vimeo from '@vimeo/player';

  export default {
    props: ['value'],
    data() {
      return {
        videoId : this.value.videoId ? this.value.videoId : '',
        muted : this.value.muted ? this.value.muted : true,
        looped : this.value.looped ? this.value.looped : true,
        player : null
      }
    },
    methods: {
      update() {
        this.$emit('input', {
          videoId : this.videoId,
          muted : this.muted,
          looped : this.looped
        });
        this.updatePlayer();
      },
      createPlayer() {

        // the Vimeo SDK throws when neither an id nor a url is given
        if (!this.videoId) return;

        const options = {
          id : this.videoId,
          width : '100%',
          height : '100%',
          loop : this.looped,
          autoplay : true,
          muted : this.muted
        }

        const player = new Vimeo(this.$refs.preview, options);
        player.play().catch(() => {});
        this.player = player;

      },
      updatePlayer() {
        this.destroyPlayer();
        this.createPlayer();
      },
      destroyPlayer() {
        if (!this.player) return;
        this.player.destroy().catch(() => {});
        this.player = null;
      }
    },
    mounted() {
      this.createPlayer();
    },
    beforeDestroy() {
      this.destroyPlayer();
    }
  }

</script>

<style scoped>

  .vimeo-preview-player {
    width : 100%;
    height : 100%;
  }
</style>
